/* eslint-disable */

import SettingsElement from "../../../ui-components/settings-element/settings-element";

import IconChevron from "../../../ui-components/icon-chevron/icon-chevron";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getRaindropOrganisationId } from "../../../services/fake-service";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import Currency from "../../../ui-components/currency/currency.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";

import { computePaymentPause } from "../../../logic/logic";
import IconHappy from "../../../ui-components/icon-happy/icon-happy";
import IconPause from "../../../ui-components/icon-pause/icon-pause";
import IconPayment from "../../../ui-components/icon-payment/icon-payment";
import IconCard from "../../../ui-components/icon-card/icon-card";
import IconForeignExchange from "../../../ui-components/icon-foreign-exchange/icon-foreign-exchange";
import IconDownload from "../../../ui-components/icon-download/icon-download";

import { localize } from "../../../services/localize";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import {
  fetchAccountPlanExecutions,
  fetchOrganisationGet,
} from "../../../services/api-raindrop";

const PaymentElementOrganisation = ({ payment }) => {
  const [organisation, setOrganisation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrganisationGet({
      organisationId: payment.organisationId,
    })
      .then((org) => {
        setOrganisation(org);
      })
      .catch((e) => {
        console.log("🟢 (RD-563) - ", e);
        setError(e);
      });
  }, [payment.organisationId]);

  if (organisation === null) {
    return <div>Loading</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const icon = (
    <OrganisationLogo organisationId={organisation.id} className={"w-8 h-8"} />
  );

  let note = "";

  if (payment.organisationId === getRaindropOrganisationId()) {
    note = "This is the Sapphire Version";
  }

  return (
    <PaymentElement
      icon={icon}
      title={organisation.title}
      paymentAmount={payment.paymentAmount}
      paymentCurrency={payment.paymentCurrency}
      paymentOriginalAmount={payment.paymentOriginalAmount}
      paymentOriginalCurrency={payment.paymentOriginalCurrency}
      note={note}
    />
  );
};
const PaymentElement = ({
  icon,
  title = "Default title",
  paymentAmount = "N/A",
  paymentCurrency,
  paymentOriginalAmount,
  paymentOriginalCurrency,
  note,
  highlight = false,
  isCovered = false,
}) => {
  return (
    <motion.div className={"flex flex-row w-full gap-2 items-center"}>
      {icon && <div>{icon}</div>}
      <div className={"flex flex-col items-start text-left text-sm"}>
        <div className={highlight ? "font-bold" : ""}>{title}</div>
        <div className={"text-xs opacity-50 text-color-text-secondary"}>
          {note}
        </div>
      </div>

      {isCovered && (
        <div
          className={"ml-auto text-xs font-bold text-color-raindrop-primary"}
        >
          We paid for you
        </div>
      )}
      {!isCovered && (
        <div className={"flex flex-col ml-auto"}>
          <Currency
            className={"justify-end " + (highlight ? "font-bold" : "")}
            amount={
              paymentOriginalAmount ? paymentOriginalAmount : paymentAmount
            }
            currency={
              paymentOriginalCurrency
                ? paymentOriginalCurrency
                : paymentCurrency
            }
          />
          {paymentOriginalAmount && (
            <Currency
              amount={paymentAmount}
              currency={paymentCurrency}
              className={"text-[12px] justify-end text-color-text-secondary"}
            />
          )}
        </div>
      )}
    </motion.div>
  );
};

const FileDownloadButton = ({ text }) => {
  return (
    <div
      className={
        "flex flex-row rounded-lg p-2 px-3 gap-1 text-xs opacity-60 bg-color-raindrop-disabled"
      }
    >
      <IconDownload className={"w-6 fill-white"} />
      <div className={"w-full"}>{text}</div>
    </div>
  );
};

const PlanExecutionElement = ({ planExecution }) => {
  const [expanded, setExpanded] = useState(false);

  let hover = "hover:scale-95 transition-all";
  if (expanded) {
    hover = "";
  }
  return (
    <motion.div
      id={planExecution.id}
      key={planExecution.id}
      className={`border-b border-color-border-primary ${hover}`}
    >
      <PlanExecutionElementHeader
        icon={"payment"}
        text={"Payment distributed"}
        date={planExecution.createdAt}
        onClick={() => setExpanded(!expanded)}
      />

      {expanded && (
        <div
          id={planExecution.id + "body"}
          className={"flex flex-col gap-5 px-2  "}
        >
          <RaindropDivider width={0.5} />

          {planExecution.payments.map((payment, i) => (
            <PaymentElementOrganisation
              payment={payment}
              key={`plan-execution-${i}`}
            />
          ))}

          <PaymentElement
            icon={
              <div
                className={
                  "flex flex-col items-center justify-center w-8 h-8 rounded-lg bg-color-raindrop-minor"
                }
              >
                <IconForeignExchange
                  className={"w-6 h-6 fill-white opacity-30"}
                />
              </div>
            }
            title={"Foreign Exchange (FX) Fee"}
            isCovered={true}
          />
          <PaymentElement
            icon={
              <div
                className={
                  "flex flex-col items-center justify-center w-8 h-8 rounded-lg bg-color-raindrop-minor"
                }
              >
                <IconCard className={"w-5 h-5 fill-white opacity-30"} />
              </div>
            }
            title={"Card Transaction Fee"}
            isCovered={true}
          />

          <RaindropDivider width={0.5} />

          <PaymentElement
            title={"Total you paid"}
            paymentAmount={97.77}
            paymentCurrency={"GBP"}
            paymentOriginalCurrency={"NZD"}
            paymentOriginalAmount={200}
            highlight
          />
          <div
            className={"flex flex-row items-center justify-center gap-5 p-2"}
          >
            <FileDownloadButton text={"PDF"} />
            <FileDownloadButton text={"CSV"} />
            <FileDownloadButton text={"XLSX"} />
          </div>
        </div>
      )}
    </motion.div>
  );
};

const PlanExecutionElementHeader = ({ icon, text, date, onClick }) => {
  let backgroundColor = "bg-color-raindrop-minor";
  let iconComponent = null;

  if (icon === "happy") {
    backgroundColor = "bg-color-raindrop-primary";
    iconComponent = <IconHappy className={"w-8 h-8 fill-white opacity-50"} />;
  }
  if (icon === "pause") {
    iconComponent = <IconPause className={"w-5 fill-color-raindrop-primary"} />;
  }
  if (icon === "payment") {
    iconComponent = <IconPayment className={"w-8 h-8 fill-white opacity-50"} />;
  }

  const options = { day: "numeric", month: "long", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);

  return (
    <motion.div
      id={"date-started-element"}
      className={"flex flex-row p-2 gap-2 items-center w-full"}
      onClick={onClick}
    >
      <div
        className={`flex items-center justify-center w-10 h-10 rounded-md  ${backgroundColor}`}
      >
        {iconComponent}
      </div>

      <div className={"flex flex-col items-start"}>
        <div className={"text-xs text-color-text-secondary"}>
          {formattedDate}
        </div>

        <div className={"text-sm"}>{text}</div>
      </div>
      {onClick && <IconChevron className={"ml-auto -rotate-90"} />}
    </motion.div>
  );
};

const PlanExecutionList = ({ planExecutions }) => {
  let previousDate = null;
  return (
    <RaindropScrollContainer>
      {planExecutions.map((planExecution, i) => {
        const [wasPaused, pausedDate, monthDiff] = computePaymentPause(
          planExecution.createdAt,
          previousDate,
        );
        previousDate = new Date(planExecution.createdAt);
        return (
          <div className="w-full">
            {wasPaused && (
              <PlanExecutionElementHeader
                icon={"pause"}
                date={pausedDate}
                text={`You paused your payments for ${monthDiff} months`}
                key={`plan-execution-pause-${i}`}
              />
            )}
            <PlanExecutionElement
              planExecution={planExecution}
              key={`plan-execution-element-${i}`}
            />
          </div>
        );
      })}
      <PlanExecutionElementHeader
        icon={"happy"}
        date={new Date(2023, 3, 8)} // TODO: This is a fake date
        text={"You joined The Raindrop Company 🎉"}
      />
    </RaindropScrollContainer>
  );
};

const RaindropPayments = ({ userCurrent }) => {
  const pE = (i) => {
    const date = new Date();
    date.setMonth(date.getMonth() - i);

    return {
      id: "plan_execution_1088FEB5-45C0-4755-890F-78763CDEF68E",
      planId: "plan_D58C1D1F-DB14-45D4-9486-5824EC37C507",
      createdAt: date,
      paymentAmount: 200,
      paymentCurrency: "NZD",
      paymentOriginalAmount: 200,
      paymentOriginalCurrency: "NZD",
      payments: [
        {
          id: "payment_4942A36D-988C-47A4-9B91-B43DF1354F1B",
          organisationId: "organisation_EEAA5B09-5126-4C37-A7DF-2506B237DD93",
          paymentAmount: 29.33,
          paymentCurrency: "GBP",
          paymentOriginalAmount: 60,
          paymentOriginalCurrency: "NZD",
          createdAt: "2021-09-01T00:00:00.000Z",
          status: "PAID",
        },
        {
          id: "payment_4942A36D-988C-47A4-9B91-B43DF1354F1B",
          organisationId: "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C",
          paymentAmount: 58.66,
          paymentCurrency: "GBP",
          paymentOriginalAmount: 120,
          paymentOriginalCurrency: "NZD",
          createdAt: "2021-09-01T00:00:00.000Z",
          status: "PAID",
        },
        {
          id: "payment_93597D4A-F7CF-4824-B235-2366B8AA1D84",
          organisationId: "organisation_77436E14-0DBC-44C6-8F2B-400DFB056724",
          paymentAmount: 9.78,
          paymentCurrency: "GBP",
          paymentOriginalAmount: 20,
          paymentOriginalCurrency: "NZD",
          createdAt: "2021-09-01T00:00:00.000Z",
          status: "PAID",
        },
      ],
    };
  };
  const planExecutions = [0, 1, 2, 5, 6, 7, 8, 12, 13, 14, 15, 16].map((v, i) =>
    pE(v),
  );

  const [accountPlanExecutions, setAccountPlanExecutions] = useState([]);

  useEffect(() => {
    fetchAccountPlanExecutions({
      accountId: userCurrent.accountId,
    }).then((planExecutions) => {
      console.log("🟢 (RD-123) - ", planExecutions);
      setAccountPlanExecutions(planExecutions);
    });
  });

  return (
    <div className={"flex flex-col h-full w-full"}>
      <SettingsElement
        id={"settings-element-payments"}
        title={localize("COPY_SETTINGS_PAYMENTS")}
        icon={<IconPayment className={"w-6 fill-white opacity-60"} />}
      />

      <PlanExecutionList planExecutions={planExecutions} />
    </div>
  );
};
export default RaindropPayments;
